import { useEffect, useState } from "react";
import { useRootTypeContext } from "../rootTypes/context/RootTypeContext";
import { getRootTypes } from "../rootTypes/repositories/RootTypes";
import { getRoots } from "../roots/repositories/Root";
import { TableDressCache } from "./components/DataTable/TableDressCache";
import { useDressCacheContext } from "./context/DressCacheContext";

export const UpdateDressCachePage = () => {
	const { state, actions } = useDressCacheContext();
	const { state: rootTypes, actions: rootTypesActions } = useRootTypeContext();

	const [isLoading, setIsLoading] = useState(true);
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getRootsFromAPI = async () => {
		setIsLoading(true);
		const values = await Promise.all([getRoots(), getRootTypes()])
			.then((r) => {
				const [rootsResp, rootTypeResp] = r;

				if (rootsResp.ok && rootTypeResp.ok) {
					actions.setRoots(rootsResp?.roots);
					rootTypesActions.setRootTypes(rootTypeResp?.rootTypes);
					setIsLoading(false);
				}
			})
			.catch((e) => {
				setFetchDataError(e);
				setShowErrorModal(true);
			});
	};

	useEffect(() => {
		getRootsFromAPI();
	}, []);
	return (
		<div>
			<TableDressCache
				isLoading={isLoading}
				getRootsFromAPI={getRootsFromAPI}
			/>
		</div>
	);
};
